export enum GoalSetterInteractionType {
    Dismiss = 'Dismiss',
    Complete = 'Complete',
    Continue = 'Continue'
}
